import { Component, OnInit, Input, ViewChild, Output, EventEmitter,Injectable, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators, FormControl, FormArray } from '@angular/forms';

//import { Component, OnInit, ViewChild,Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { LoginService } from '../Services/Login/login.service';
import { CommonService } from '../Services/common.service';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { timer } from 'rxjs';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { LocationStrategy } from '@angular/common'; 

declare let $: any;
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-inner-header',
  templateUrl: './inner-header.component.html',
  styleUrls: ['./inner-header.component.css']
})
export class InnerHeaderComponent implements OnInit,AfterViewInit {
  logonfrom:FormGroup;
  capthcacode: number;
  capthcacode1: number;
  loading= false;
  isotp:boolean=false;
  isLoggedIn:boolean=false;
  buttontext='Send OTP';
  loginValidations: any = {};
  capthcacodetotal: number;
  usermobileNo: any;
  constructor(private _CommonService: CommonService, private _loginService: LoginService, private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router,private readonly http: HttpClient, private _CookieService: CookieService, private location: LocationStrategy) { 

    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {  
    history.pushState(null, null, window.location.href);
    });  


  }

  ngOnInit() {
    this.capthcacode =  Math.floor((Math.random() * 10) + 1);
    this.capthcacode1 =  Math.floor((Math.random() * 20) + 1);
    this.capthcacodetotal = this.capthcacode+ this.capthcacode1;
    this.logonfrom = this.formBuilder.group({
      pmobileno: ['', [Validators.required, Validators.minLength(10)]],
      potp: ['', [Validators.required, Validators.minLength(6)]],
     //  potp: ['']
     capthcacode:['',[Validators.required, Validators.minLength(1)]]
    });
    this.BlurEventAllControll(this.logonfrom);
    
  }
  callMyCount(){    
    document.getElementById('timer').innerHTML ="02" +" "+"Minutes"+" " + ":" + "00" +" "+ " Seconds to Resend OTP";
    var myTimer=setInterval(startTimer,1000);
  
    function startTimer() {
      var presentTime = document.getElementById('timer').innerHTML;
      var timeArray = presentTime.split(/[:]+/);
      var m = parseInt(timeArray[0]);
      var s = checkSecond((parseInt(timeArray[1]) - 1));
      if(s==59){m=m-1}
      if(m<0 && s==59){
                       clearTimeout(myTimer);
                       document.getElementById('timer').innerHTML ="";
                       var eleman = document.getElementById("Send");
                       eleman.removeAttribute("disabled");
                      
                      }
                      else
                      {
      document.getElementById('timer').innerHTML =  m +" "+"Minutes"+" " +":" + s +" "+ " Seconds to Resend OTP";;
                      }
    }
  
    function checkSecond(sec) {
      if (sec < 10 && sec >= 0) {sec = "0" + sec}; 
      if (sec < 0) {sec = "59"};
      return sec;
    }
  }


  BlurEventAllControll(fromgroup: FormGroup) {
   // document.getElementById('lblstatus').innerHTML='';
    try {
      Object.keys(fromgroup.controls).forEach((key: string) => {
        this.setBlurEvent(fromgroup, key);
      })
    }
    catch (e) {
     // this.showErrorMessage(e);
      return false;
    }
  }
  setBlurEvent(fromgroup: FormGroup, key: string) {
    try {
      let formcontrol;
      formcontrol = fromgroup.get(key);
      if (formcontrol) {
        if (formcontrol instanceof FormGroup) {
          this.BlurEventAllControll(formcontrol)
        }
        else {
          if (formcontrol.validator)
            fromgroup.get(key).valueChanges.subscribe((data) => { this.GetValidationByControl(fromgroup, key, true) })
        }
      }
    }
    catch (e) {
     // this.showErrorMessage(e);
      return false;
    }
  }
  GetValidationByControl(formGroup: FormGroup, key: string, validate: boolean): boolean {
    try {
      let formcontrol;
      formcontrol = formGroup.get(key);
      if (formcontrol) {
        if (formcontrol instanceof FormGroup) {
          this.checkValidations(formcontrol, validate)
        }
        else if (formcontrol.validator) {
          this.loginValidations[key] = '';
          if (formcontrol.errors || formcontrol.invalid || formcontrol.touched || formcontrol.dirty) {
            let lablename;
            lablename = (document.getElementById(key) as HTMLInputElement).title;
            let errormessage;
            for (const errorkey in formcontrol.errors) {
              if (errorkey) {
                errormessage = this._CommonService.getValidationMessage(formcontrol, errorkey, lablename, key, '');
                this.loginValidations[key] += errormessage + ' ';
                validate = false;
              }
            }
          }
        }
      }
    }
    catch (e) {
      //this.showErrorMessage(e);
      return false;
    }
    return validate;
  }
  checkValidations(group: FormGroup, validate: boolean): boolean {

    try {
      Object.keys(group.controls).forEach((key: string) => {
        validate = this.GetValidationByControl(group, key, validate);
      })
    }
    catch (e) {
     // this.showErrorMessage(e);
      return false;
    }
    return validate;
  }

  verifyclick()
  {

    let validate=true;
    let mobileno;
    let otp;
    if (this.checkValidations(this.logonfrom, validate)) {
      if(this.capthcacodetotal == this.logonfrom.controls.capthcacode.value){
         mobileno=this.logonfrom.controls.pmobileno.value;
         otp=this.logonfrom.controls.potp.value;
      }else{
        return alert("Enter Valid Capthca Number");
      }
    
    this._loginService._verifyotp(mobileno,otp).subscribe(result => {
   
     if(result['pstatus']==true)
{
     
      document.getElementById('lblstatus').innerHTML = result['pmessage'];
      document.getElementById('lblstatus').style.color ="green";
      sessionStorage.setItem('currentUser',result['pmobileno']);
      sessionStorage.setItem('pToken',result['pToken']);
      sessionStorage.setItem("dateformat","DD-MMM-YYYY");          
      sessionStorage.setItem('UFM',result['pmobileno']);
       this.router.navigate(['/MyChits']);  
      
     // window.location.reload();
     $('#modalForm').modal('hide');
        //$("#").modal("hide");
}

if(result['pstatus']==false)
{
  document.getElementById('lblstatus').innerHTML = result['pmessage'];
  document.getElementById('lblstatus').style.color ="red";


}
      
      });
    }
  }

  ngAfterViewInit() {
    const isLogged = sessionStorage.getItem('pToken');
    if (isLogged !== "" && isLogged !== null){
      this.isLoggedIn = true;
      this.usermobileNo=sessionStorage.getItem('currentUser');
    }
  }

  onlyNumberKey(event) {
    if (event.target.value.length == 0 && event.which == 48) {
      return false;
       }
       else
       {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
       }
}
  change(ev)
  {
if(ev.value=='' ||ev.value==undefined || ev.value==null ||ev.value.length<10)
{
  document.getElementById('lblstatus').innerHTML ="";
}
  }
  changeotp(ev)
  {
    if(ev.value=='' ||ev.value==undefined || ev.value==null ||ev.value.length<6)
{

  document.getElementById('lblstatus').innerHTML ="";
}
  }
  ngclick()
  {

//     let validate = true;
      
//     if (this.checkValidations(this.logonfrom, validate)) {
     
 let mobileno=this.logonfrom.controls.pmobileno.value;

 if(mobileno!='')
 {

if(mobileno!=null && mobileno!=undefined && mobileno!='')
{
    this._loginService._getloginotp(mobileno).subscribe(result => {
if(result!=null)
{
if(result['pstatus']==true)
{

var eleman = document.getElementById("Send");
    eleman.setAttribute("disabled","true");

      this.buttontext='Resend OTP';
      document.getElementById('lblstatus').style.color ="green";
      document.getElementById('lblstatus').innerHTML = result['pmessage'];
      sessionStorage.setItem('currentUser',result['pmobileno']);
      this.callMyCount();     
}
if(result['pstatus']==false)
{
  document.getElementById('lblstatus').style.color ="red";
  document.getElementById('lblstatus').innerHTML = result['pmessage'];

}
}
else
{
  document.getElementById('lblstatus').innerHTML = "NO ";

}
    });
  }
  else
  {
alert("Enter Valid Mobile Number");
  }
}
else
{
  alert("Enter Mobile Number");

}
   }

   Logout() {
    this._loginService.Logout();
  }
}
